function sortList(dataToSort) {
  return dataToSort.sort((a, b) => (a.Name > b.Name ? 1 : -1));
}

export { sortList };
